import React, { useEffect, useState } from "react";
import Banner from '../components/banner';
import Button from '../components/button/index';
import '../scss/component/_section.scss';
import '../scss/component/_box.scss';
import '../scss/component/_tf-section.scss';
import '../scss/component/_reponsive.scss';

const API_BASE = "https://claiming.kwicdashboard.io"; // adjust if needed

const POLICY_KEYS = {
  KWIC_OG: "KWICOG",
  KWIC_1OF1: "KWIC1OF1",
  KWIC_ORDINAL: "KWICORDINAL",
  PLAYABLE_AVATAR: "PLAYABLEAVATAR",
  PLAYABLE_AVATAR_SUMMONS: "PLAYABLEAVATARSUMMONS"
};

function isHex(str) { return /^[0-9a-f]+$/i.test(str); }
function tryHexToUtf8(hex) {
  try { return hex ? decodeURIComponent(hex.replace(/(..)/g, '%$1')) : ""; } catch { return ""; }
}
function parseToAssetHex(input) {
  const s = (input || "").trim().toLowerCase().replace(/^0x/, "");
  if (!isHex(s)) return null;
  if (s.length >= 56) return s.slice(56); // treat as Unit ID (policyId + assetNameHex)
  return s; // treat as plain assetNameHex
}

function Home() {
  const [claimedStats, setClaimedStats] = useState(() => {
    try {
      const local = localStorage.getItem("claimedStats");
      return local ? JSON.parse(local) : {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    const fetchClaimedStats = async () => {
      try {
        const res = await fetch(`${API_BASE}/claimed-stats`);
        const data = await res.json();
        const statsMap = {};
        data.forEach(({ category, count }) => { statsMap[category] = count; });
        setClaimedStats(statsMap);
        localStorage.setItem("claimedStats", JSON.stringify(statsMap));
      } catch (err) {
        console.error("Failed to fetch claimed stats:", err);
      }
    };
    fetchClaimedStats();
  }, []);

  return (
    <div className="header-fixed main home3 counter-scroll" data-aos-delay="200" data-aos="fade-up" data-aos-duration="300">
      <Banner />

      <section className="home-section" data-aos-delay="200" data-aos="fade-up" data-aos-duration="200">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 center">
              <h1>$KWIC</h1>
              <h4>This is the KWIC ecosystem utility token.</h4>
              <Button
                title="BUY $KWIC TOKEN"
                onClick={() => window.location.href = "https://app.vyfi.io/dex?tokenA=lovelace&tokenB=b3ad8b975d24235a43cb2a54d58c717ed9dd11560b4deba2273ffb1d0014df104b574943"}
                addclass="stake_btn buy_btn"
              />
            </div>

            <div className="col-lg-12 center mt-100">
              <h2>ASSETS CLAIM STATUS</h2>
            </div>

              <section className="">
                <div className="container">
                  <div className="row">
                    <ClaimLookup />
                  </div>
                </div>
              </section>

            <div className="col-lg-12 center mt-100">
              <h2>TOTAL CLAIMS</h2>
            </div>
            
            <StatsCard title="KWIC OG" value={claimedStats[POLICY_KEYS.KWIC_OG]} />
            <StatsCard title="KWIC ART 1 OF 1" value={claimedStats[POLICY_KEYS.KWIC_1OF1]} />
            <StatsCard title="KWIC ORDINAL REWARDS" value={claimedStats[POLICY_KEYS.KWIC_ORDINAL]} />
            <div className="col-lg-2"></div>
            <StatsCard title="PLAYABLE AVATARS" value={claimedStats[POLICY_KEYS.PLAYABLE_AVATAR]} />
            <StatsCard title="PLAYABLE AVATAR SUMMONS" value={claimedStats[POLICY_KEYS.PLAYABLE_AVATAR_SUMMONS]} />

            
          </div>
        </div>
      </section>
    </div>
  );
}

function ClaimLookup() {
  const [mode, setMode] = useState("asset"); // "asset" | "wallet"
  return (
    <div className="col-lg-12">
      <div className="staked-stats" style={{ padding: 20 }}>
        {/* Tabs, using your existing button look */}
        <div className="row" style={{ marginBottom: 12 }}>
          <div className="col-lg-12 center" style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Button
              title="By Asset ID"
              addclass={`filter_btn ${mode === "asset" ? "" : "btn-inactive"}`}
              onClick={() => setMode("asset")}
            />
            <Button
              title="By Wallet Address"
              addclass={`filter_btn ${mode === "wallet" ? "" : "btn-inactive"}`}
              onClick={() => setMode("wallet")}
            />
          </div>
        </div>

        {mode === "asset" ? <LookupByAsset /> : <LookupByWallet />}
      </div>
    </div>
  );
}

/* --- Asset ID lookup (keeps your current styles/flow) --- */
function LookupByAsset() {
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [resu, setResu] = useState(null);

  const handleCheck = async (e) => {
    e?.preventDefault?.();
    setErr(""); setResu(null);

    const assetHex = parseToAssetHex(input);
    if (assetHex == null) {
      setErr("Enter a valid hex: Unit ID (policyId+assetNameHex) or just assetNameHex.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/is-claimed/${assetHex}`);
      const data = await res.json();
      if (!res.ok) setErr(data?.error || "Lookup failed");
      else setResu({
        claimed: !!data.claimed,
        asset_name_hex: data.asset_name_hex || assetHex,
        claimed_at: data.claimed_at || null
      });
    } catch {
      setErr("Network error.");
    } finally {
      setLoading(false);
    }
  };

  const prettyDate = (iso) => !iso ? "" : new Date(iso).toLocaleString();

  return (
    <>
      <form onSubmit={handleCheck}>
        <div className="row" style={{ gap: 0 }}>
          <div className="col-lg-10">
            <input
              type="text"
              className="form-control searchbar"
              placeholder="Asset ID (policyId+assetNameHex) or AssetNameHex"
              value={input}
              onChange={(e) => setInput(e.target.value)}
            />
          </div>
          <div className="col-lg-2 page-button">
            <Button title={loading ? "Checking..." : "Check"} addclass="stake_btn" onClick={handleCheck} />
          </div>
        </div>
      </form>

      {err && <p className="mt-3" style={{ color: "#e35" }}>{err}</p>}

      {resu && (
        <div className="mt-3 search-results" style={{ fontSize: 19, lineHeight: 1.6 }}>
          <div>
            <strong>STATUS:</strong>{" "}
            <span className={`${resu.claimed ? "badge-success" : "badge-warning"}`}>
              {resu.claimed ? "CLAIMED" : "NOT CLAIMED"}
            </span>
          </div>
          <div><strong>ASSETNAME HEX:</strong> {resu.asset_name_hex}</div>
          {resu.claimed_at && <div><strong>CLAIMED AT:</strong> {prettyDate(resu.claimed_at)}</div>}
        </div>
      )}
    </>
  );
}

/* --- Wallet Address lookup (filtered to your 5 policies) --- */
function LookupByWallet() {
  const [addr, setAddr] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [data, setData] = useState(null);

  // Fixed allowlist (all lowercase, 56 chars each)
  const FIXED_POLICIES = [
    "c72d0438330ed1346f4437fcc1c263ea38e933c1124c8d0f2abc6312",
    "cbb8d9d7415bbcc6f4c8a832d0437e9f6e7fe4605a1cf110ad903d82",
    "7c15d2a6be43f55000ae6ae0c31b9444a047815a8156df66d363c7a4",
    "b98ae818ee0693e61a8e51db1358240eaa441dba60a8c3766e3f5115",
    "cd1490083a247e1730d25cfbeed0ebfe57fa8c2697d7dba5fac9d2fa"
  ];
  const fixedCsv = FIXED_POLICIES.join(",");

  const handleCheck = async (e) => {
    e?.preventDefault?.();
    setErr(""); setData(null);

    const a = addr.trim();
    if (!a) { setErr("Enter a wallet address."); return; }

    setLoading(true);
    try {
      // Option A (no backend change): send CSV of fixed policies
      const res = await fetch(
        `${API_BASE}/address-claim-status/${encodeURIComponent(a)}?policyIds=${encodeURIComponent(fixedCsv)}`
      );

      // Option B (if backend already enforces the allowlist), use this instead:
      // const res = await fetch(`${API_BASE}/address-claim-status/${encodeURIComponent(a)}`);

      const json = await res.json();
      if (!res.ok) setErr(json?.error || "Lookup failed");
      else setData(json);
    } catch {
      setErr("Network error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleCheck}>
        <div className="row" style={{ gap: 0 }}>
          <div className="col-lg-10">
            <input
              type="text"
              className="form-control searchbar"
              placeholder="Wallet address (bech32)"
              value={addr}
              onChange={(e) => setAddr(e.target.value)}
            />
          </div>
          <div className="col-lg-2 page-button">
            <Button title={loading ? "Checking..." : "Check"} addclass="stake_btn" onClick={handleCheck} />
          </div>
        </div>
      </form>

      {err && <p className="mt-3" style={{ color: "#e35" }}>{err}</p>}

      {data && (
        <div className="mt-3 search-results" style={{ fontSize: 19, lineHeight: 1.6 }}>
          <div className="row">
            {data.unclaimed?.length > 0 && (
              <div className="col-lg-12 mt-3">
                <h5>UNCLAIMED ({data.unclaimedCount})</h5>
                <ul style={{ marginTop: 6 }}>
                  {data.unclaimed.slice(0, 20).map((x) => (
                    <li key={x.unit} style={{ wordBreak: "break-all" }}>
                      <span className="asset-id">Asset ID: {x.unit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {data.claimed?.length > 0 && (
              <div className="col-lg-12 mt-3">
                <h5>CLAIMED ({data.claimedCount})</h5>
                <ul style={{ marginTop: 6 }}>
                  {data.claimed.slice(0, 20).map((x) => (
                    <li key={x.unit} style={{ wordBreak: "break-all" }}>
                      <span className="asset-id">Asset ID: {x.unit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}




// Simple card component (unchanged)
function StatsCard({ title, value }) {
  return (
    <div className="col-lg-4">
      <div className="staked-stats">
        {value === undefined ? <h2>0</h2> : <h2>{value}</h2>}
        <h5>{title}</h5>
      </div>
    </div>
  );
}

export default Home;
